export default {
    computed: {
        activationBriefFieldsUrl() {
            return `/api/v1/contacts/${this.contactId}/activation-briefs/${this.briefParamId}/fields`;
        },
        briefFields() {
            return this.$root.v2.briefFields;
        },
    },
    methods: {
        loadActivationBriefFields() {
            return this.$http.get(this.activationBriefFieldsUrl)
                .then(res => this.$root.v2.briefFields = res.data);
        },
    },
};
